<template>
    <div class="container1">
		<div class="filters-box-row" :style="collapse ? 'height: 40px' : ''">
			<div class="filters-container">
				<div class="input-box">
					<span>客户名称：</span>
					<el-input
						v-model="name"
						placeholder="请输入客户名称"
						class="name-input"
						size="mini"
						@keyup.enter.native="search"
					></el-input>
				</div>
				<div class="input-box">
					<span>客户编号：</span>
					<el-input
						v-model="code"
						placeholder="请输入客户编号"
						class="name-input"
						size="mini"
						@keyup.enter.native="search"
					></el-input>
				</div>
				<div class="input-box">
					<span>客户注册码：</span>
					<el-input
						v-model="syscode"
						placeholder="请输入客户注册码"
						class="name-input"
						size="mini"
						@keyup.enter.native="search"
					></el-input>
				</div>
				<div class="input-box">
					<span>启用状态：</span>
					<el-select v-model="disabledflag" class="name-input" size='mini'>
						<el-option :value="-1" label="全部"></el-option>
						<el-option :value="0" label="启用"></el-option>
						<el-option :value="1" label="停用"></el-option>
					</el-select>
				</div>
				<div class="input-box">
					<span>客户账号：</span>
					<el-input
						v-model="account"
						placeholder="请输入客户账号"
						class="name-input"
						size="mini"
						@keyup.enter.native="search"
					></el-input>
				</div>
				<div class="input-box input-box2">
					<span>线路：</span>
					<el-input
						v-model="keyword"
						placeholder="请输入线路名称"
						class="name-input"
						size="mini"
						@keyup.enter.native="search"
					></el-input>
				</div>
				<div class="input-box input-box2">
					<span>邮箱：</span>
					<el-input
						v-model="email"
						placeholder="请输入邮箱"
						class="name-input"
						size="mini"
						@keyup.enter.native="search"
					></el-input>
				</div>
				<div class="input-box">
					<span>会员等级：</span>
					<el-select v-model="customerlevelid" class="name-input" size='mini' placeholder="请选择会员等级" clearable>
						<el-option v-for="(item,index) in fixLevelList" :key='index'  :value="item.customerlevelid" :label="item.level === 0 ? item.customerlevelname : item.levelName + (item.customerlevelname === '' ? '' : '-') + item.customerlevelname"></el-option>
					</el-select>
				</div>
				<div class="input-box">
					<span>客户标签：</span>
					<el-select v-model="customertagid" class="name-input" size='mini' placeholder="请选择客户标签" clearable>
						<el-option v-for="(item,index) in tagList" :key='index'  :value="item.customertagid" :label="item.customertagname"></el-option>
					</el-select>
				</div>
				<div class="input-box">
					<span>适用门店：</span>
					<el-select
						size="mini"
						class="name-input"
						v-model="shopNameIds"
						filterable
						multiple
						collapse-tags
						placeholder="请选择门店名称">
						<el-option label="全部" value=""></el-option>
						<template v-for="item in shopList">
							<el-option
								:key="item.id"
								:label="item.name"
								:value="item.id">
							</el-option>
						</template>
					</el-select>
				</div>
				<div class="input-box">
					<span>区域：</span>
					<el-select v-model="area" class="name-input" size='mini' @change='areaChange' placeholder="请选择区域">
						<el-option value="0" label="全国"></el-option>
						<el-option
							v-for="item in areaList"
							:key="item.code"
							:label="item.name"
							:value="item.code">
						</el-option>
					</el-select>
				</div>
				<div class="input-box">
					<span>所在地区：</span>
					<el-select v-model="province" class="name-input" style="margin-right:15px;" size='mini' @change='provinceChange()' placeholder="请选择省份">
						<el-option
							v-for="item in provinceList"
							:key="item.id"
							:label="item.name"
							:value="item.id">
						</el-option>
					</el-select>
					<el-select v-model="city" class="name-input" style="margin-right:15px;" size='mini' @change='cityChange()' placeholder="请选择城市">
						<el-option
							v-for="item in cityList"
							:key="item.id"
							:label="item.name"
							:value="item.id">
						</el-option>
					</el-select>
					<el-select v-model="district" class="name-input" size='mini' placeholder="请选择地区">
						<el-option
							v-for="(item,index) in districtList"
							:key="index"
							:label="item.name"
							:value="item.code">
						</el-option>
					</el-select>
				</div>
				<div class="input-box3">
					<span>是否使用信用额度：</span>
					<el-select v-model="creditFlag" class="name-input" size='mini' placeholder="请选择是否使用信用额度">
						<el-option :value="-1" label="全部"></el-option>
						<el-option :value="1" label="是"></el-option>
						<el-option :value="0" label="否"></el-option>
					</el-select>
					<el-select v-model="creditlinetype" class="name-input" size='mini'>
						<el-option :value="0" label="信用额度"></el-option>
						<el-option :value="1" label="已使用信用额度"></el-option>
						<el-option :value="2" label="可用信用额度"></el-option>
					</el-select>
					<el-input
						v-model="mincreditline"
						placeholder="请输入最小额度"
						class="name-input"
						size="mini"
						@keyup.enter.native="search"
					></el-input>
					<span style="margin-right: 15px;">~</span>
					<el-input
						v-model="maxcreditline"
						placeholder="请输入最大额度"
						class="name-input"
						size="mini"
						@keyup.enter.native="search"
					></el-input>
				</div>
			</div>
			<div class="search-right-wrap">
				<el-button size="small" type="text" class="btn" @click="handleCollapse">
					{{ collapse ? '展开' : '收起' }}
					<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"/>
				</el-button>
				<el-button type='primary' size='mini' style="margin-top:4px" class="fx-btn btn" @click="search">查询</el-button>
				<el-button plain size='mini' style="margin-top:4px" class="fx-btn btn" @click="clear">清空</el-button>
			</div>
		</div>
		<div class="btn-search-box">
			<el-button type='primary' plain size='mini' v-if="AuthorityList['03_0001_0005_00']" class="fx-big-btn" @click="addClick">新建</el-button>
			<el-button type='primary' plain size='mini' v-if="AuthorityList['03_0001_0013_00']"  class="fx-big-btn" @click="multiClick">批量设置</el-button>
			<div v-if="AuthorityList['03_0001_0011_00']" class="batch-register-btn"  @click="listExport" >
				<i class="excel-icon import-excel-icon"/>
				<span>客户导出</span>
			</div>
			<div v-if="AuthorityList['03_0001_0011_00']" class="batch-register-btn"  @click="listInport" >
				<i class="excel-icon import-excel-icon"/>
				<span>客户导入</span>
			</div>
			<div v-if="AuthorityList['03_0001_0010_00']"  class="batch-register-btn" @click="privateClick1">
				<i class="excel-icon import-excel-icon"/>
				<span>私密商品导入模版</span>
			</div>
			<div v-if="AuthorityList['03_0001_0010_00']"  class="batch-register-btn" @click="privateClick">
				<i class="excel-icon import-excel-icon"/>
				<span>私密商品导入</span>
			</div>
			<div v-if="AuthorityList['03_0001_0011_00']" class="batch-register-btn"  @click="privateDownloadClick" >
				<i class="excel-icon import-excel-icon"/>
				<span>私密商品导出明细</span>
			</div>
			<input type="file" ref="file" id="file" accept=".xlsx" v-show="false" @change="getFile">
		</div>
		<div class="table-box">
			<el-table
				size='mini'
				class="grid-content"
				ref='table'
				@row-dblclick='rowClick'
				:data="tableData"
				:height="tableHeight"
				@select="handleSelectionChange"
				@select-all="handleSelectionChange"
				border>
				<el-table-column
					fixed="left"
					type="selection"
					align="center"
					width="50">
				</el-table-column>
				<el-table-column
					fixed="left"
					prop="customerName"
					label="客户名称"
					align="center"
					min-width="180">
				</el-table-column>
				<el-table-column
					fixed="left"
					prop="customerAccount"
					label="客户账号"
					align="center"
					min-width="180">
				</el-table-column>
				<el-table-column
					label="客户编号"
					prop='customerCode'
					width="100"
					align="center">
				</el-table-column>
				<el-table-column
					prop="customerCategoryName"
					label="客户类别"
					align="center"
					min-width="160">
				</el-table-column>
				<el-table-column
					prop="disabledflag"
					label="启用状态"
					align="center"
					min-width="90">
					<template slot-scope="scope">
						<span v-if='scope.row.disabledflag === false'>启用</span>
						<span v-else>停用</span>
					</template>
				</el-table-column>
				<el-table-column
					label="适用门店"
					align="center"
					min-width="150">
					<template slot-scope="scope">
						<div style="color: var(--fx-primary-color);" v-if="scope.row.relallshopflag">全部门店</div>
						<el-tooltip v-else class="item" effect="dark" :content="scope.row.shopnames" placement="top">
							<div slot="content">
								<span v-for="(item, index) in scope.row.shops" :key="item.id">{{item.name}}<i v-show="index !== scope.row.shops.length - 1">、</i></span>
							</div>
							<div style="color: var(--fx-primary-color);">{{scope.row.relshopcount}}家</div>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column
					prop="linename"
					label="所属线路"
					align="center"
					min-width="150">
				</el-table-column>
				<el-table-column
					prop="syscode"
					label="客户注册码"
					align="center"
					min-width="150">
				</el-table-column>
				<el-table-column
					prop="creditlineflag"
					label="使用信用额度"
					align="center"
					min-width="150">
					<template slot-scope="scope">
						{{scope.row.creditlineflag ? '是' : '否'}}
					</template>
				</el-table-column>
				<el-table-column
					prop="creditline"
					label="信用额度"
					align="center"
					min-width="150">
					<template slot="header">
						<div style="display:inline-block;">信用额度
							<el-tooltip class="item" effect="dark" content="信用额度是卖家在后台设置的买家可以在未支付下，可下单的额度数值。" placement="top">
								<img src="~/images/icon/tooltip-icon.png" style="display:inline-block;">
							</el-tooltip>
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="usedcreditline"
					label="已使用信用额度"
					align="center"
					min-width="150">
					<template slot="header">
						<div style="display:inline-block;">已使用信用额度
							<el-tooltip class="item" effect="dark" content="已使用信用额度是使用信用额度下单，但是未支付订单的金额合计。" placement="top">
								<img src="~/images/icon/tooltip-icon.png" style="display:inline-block;">
							</el-tooltip>
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="usablecreditline"
					label="可用信用额度"
					align="center"
					min-width="150">
					<template slot="header">
						<div style="display:inline-block;">可用信用额度
							<el-tooltip class="item" effect="dark" content="" placement="top">
								<div slot="content">
									<span>1.可用信用额度 = 信用额度 - 已使用余额</span><br/>
									<span>2.支持买家在不支付订单下可提单的金额。</span>
								</div>
								<img src="~/images/icon/tooltip-icon.png" style="display:inline-block;">
							</el-tooltip>
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="customerlevelname"
					label="会员等级"
					align="center">
					<template slot-scope="scope">
						{{scope.row.level === 0 ? scope.row.customerlevelname : scope.row.levelName + (scope.row.customerlevelname === '' ? '' : '-') + scope.row.customerlevelname }}
					</template>
				</el-table-column>
				<el-table-column
					prop="customertagname"
					label="客户标签"
					align="center">
				</el-table-column>
				<el-table-column
					prop="hiddenPriceFlag"
					label="价格隐藏"
					align="center">
					<template slot-scope="scope">
						{{scope.row.hiddenPriceFlag ? '隐藏' : '显示'}}
					</template>
				</el-table-column>
				<el-table-column
					prop="area"
					label="归属区域"
					align="center">
				</el-table-column>
				<el-table-column
					prop="addr"
					label="所在地区"
					align="center"
					min-width="130">
				</el-table-column>
				<el-table-column
					prop="email"
					label="邮箱"
					align="center">
				</el-table-column>
				<el-table-column
					prop="memo"
					label="备注"
					align="center">
				</el-table-column>
				<el-table-column label="操作" width="180" align="center">
					<template slot-scope="scope">
						<el-button size="mini" type='text' v-if="AuthorityList['03_0001_0001_00'] || AuthorityList['03_0001_0003_00']" icon="el-icon-search" @click="showClick(scope.row)">查看</el-button>
						<el-button size="mini" type='text' v-if="AuthorityList['03_0001_0007_00']" icon="el-icon-delete" @click="deleteClick(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>

		</div>

		<el-pagination
			style="margin-top:5px;"
			@size-change="handleSizeChange"
			@current-change="handlePageChange"
			:current-page="page.num"
			:page-sizes="[20, 40, 60, 100, 300]"
			:page-size="page.size"
			layout="total, sizes, prev, pager, next, jumper"
			:total="total">
		</el-pagination>

		<el-dialog title="批量生成客户码" class="confirm-dialog" @close="cancelAddCode" top='60px' :visible.sync="addCodeListModel" width='500px' :close-on-click-modal="false">
			<div class="dialog-container">
				<div class="input-box">
					<span style="color:red">*</span>
					<span>批量生成客户码个数:</span>
					<el-input v-model="codeNumber" @blur="changeNumber" type='number' size='mini' class="input-span"></el-input>
					<span v-if="waring" style="color:red;margin-left:10px">请输入1-50的数字</span>
				</div>
				<div class="input-box">
					<span style="margin-left:90px">业务员:</span>
					<el-select v-model="ListStaffid" class="input-span" clearable filterable size='mini'>
						<el-option
						v-for="(item,index) in staffList"
						:key="index"
						:label="`${item.staffNumber}-${item.staffName}`"
						:value="item.staffid">
						</el-option>
					</el-select>
				</div>

				<div class="btn-box">
					<el-button size="small" class="btn" plain type="primary" @click="cancelAddCode">取消</el-button>
					<el-button size="small" class="btn" plain type="primary" @click="saveCode">确认</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog title="批量设置" class="confirm-dialog" top='60px' @close="cancelLine" :visible.sync="multiSetModel" width='600px' :close-on-click-modal="false">
			<div class="dialog-container">
				<div class="input-box">
					<span style="margin-right:20px;">将字段</span>
					<el-select v-model="lineSelect" class="input-span" size='mini' @change="changeSelect">
						<el-option label="所属线路" value="0"></el-option>
						<el-option label="客户支付方式" value="1"></el-option>
						<el-option label="客户类别" value="17"></el-option>
						<el-option label="会员等级" value="2"></el-option>
						<el-option v-if="AuthorityList['03_0001_0008_00'] || AuthorityList['03_0001_0009_00']" label="启用状态" value="3"></el-option>
						<el-option v-if="AuthorityList['03_0001_0007_00']" label="删除" value="4"></el-option>
						<el-option label="推送至中台" v-if="matchbillcenterflag && AuthorityList['03_0001_0003_00']" value="5"></el-option>
						<el-option label="线上开票" value="18"></el-option>
						<el-option label="批量充值信用额度" value="6"></el-option>
						<el-option label="是否使用信用额度下单" value="7"></el-option>
						<el-option label="适用门店" value="8"></el-option>
						<el-option label="价格隐藏" value="9"></el-option>
						<el-option label="批量删除客户专有价格" value="10"></el-option>
						<el-option label="批量删除客户与商品关系" value="11"></el-option>
						<el-option label="附录1" value="12"></el-option>
						<el-option label="附录2" value="13"></el-option>
						<el-option label="好友代付" value="14"></el-option>
						<el-option label="退款方式" value="15"></el-option>
					</el-select>
				</div>
				<div class="input-box" v-if="lineSelect === '0'">
					<div class="change-title">修改为</div>
					<div class="change-right">
						<div class="">
							<el-radio v-model="lineRadio" label="1">新值</el-radio>
							<el-radio v-model="lineRadio" label="2">清空数据</el-radio>
						</div>
						<div v-show="lineRadio === '1'">
							<div class="line-box" style="margin-right:20px;">
								<div class="box_title">已选择关联数据 (关联数据{{selectLineList.length}}条)</div>
								<div class="box_list">
									<ul class="cl member">
										<li v-for="item in selectLineList" :key="item.lineid"><span class="mod_appicon"><span :title="item.codeandname" style="width:100%">{{item.codeandname}}</span></span><span></span></li>
									</ul>
								</div>
							</div>
							<div class="line-box">
								<div class="box_search">
									<i class="el-icon-search" style="margin-left:6px;"></i><input class="px px_search" placeholder="搜索" v-model="lineValue" @input="lineInput">
								</div>
								<div class="box_list_body">
									<div class="box_list box_list_main">
										<ul class="cl member">
											<li v-for="item in lineList" :key="item.lineid" @click="selectLine(item)">
												<div class="line-check" v-if="item.checked"><img src="~/images/icon/line-selected.png" alt=""></div>
												<div class="line-check" v-else><img src="~/images/icon/line-select.png" alt=""></div>
												<span class="mod_appicon"><span :title="item.codeandname">{{item.codeandname}}</span></span>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="input-box" v-if="lineSelect === '2'">
					<div class="change-title">修改为</div>
					<div class="change-right">
						<div class="">
							<el-radio v-model="levelRadio" label="1">新值</el-radio>
							<el-radio v-model="levelRadio" label="2">清空数据</el-radio>
						</div>
						<div v-show="levelRadio === '1'">
							<div class="line-box" style="margin-right:20px;">
								<div class="box_title">已选择关联数据 (关联数据{{selectLevelList.length}}条)</div>
								<div class="box_list">
									<ul class="cl member">
										<li v-for="item in selectLevelList" :key="item.customerlevelid"><span class="mod_appicon"><span :title="item.customerlevelname" style="width:100%">{{item.level === 0 ? item.customerlevelname : item.levelName + (item.customerlevelname === '' ? '' : '-') + item.customerlevelname}}</span></span><span></span></li>
									</ul>
								</div>
							</div>
							<div class="line-box">
								<div class="box_search">
									<i class="el-icon-search" style="margin-left:6px;"></i><input class="px px_search" placeholder="搜索" v-model="levelValue" @input="levelInput">
									<i class="el-icon-circle-plus-outline add-icon" @click="addLevel"></i>
								</div>
								<div class="box_list_body">
									<div class="box_list box_list_main">
										<ul class="cl member">
											<li v-for="item in levelList" :key="item.customerlevelid" @click="selectLevel(item)">
												<div class="line-check" v-if="item.checked"><img src="~/images/icon/line-selected.png" alt=""></div>
												<div class="line-check" v-else><img src="~/images/icon/line-select.png" alt=""></div>
												<span class="mod_appicon"><span :title="item.customerlevelname">{{item.level === 0 ? item.customerlevelname : item.levelName + (item.customerlevelname === '' ? '' : '-') + item.customerlevelname}}</span></span>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="input-box" v-if="lineSelect === '1'">
					<div class="change-title"></div>
					<div class="change-right">
						<div class="">
							<el-radio v-model="payWayRadio" label="1">修改为</el-radio>
							<el-radio v-model="payWayRadio" label="2">删除</el-radio>
						</div>
						<el-checkbox-group class="pay-type-box" style="margin-top:15px" v-model="payTypeRadio" v-if="payWayRadio === '1'">
							<!-- <el-checkbox label="0">不限</el-checkbox> -->
							<el-checkbox label="0">线下支付</el-checkbox>
							<el-checkbox label="2" :disabled="payTypeRadio.includes('6')">微信支付</el-checkbox>
							<el-checkbox label="4">预付货款</el-checkbox>
							<el-checkbox label="6" :disabled="payTypeRadio.includes('2')">微企付</el-checkbox>
							<el-checkbox label="7">云资金-网商余额支付</el-checkbox>
							<el-checkbox label="8">云资金-汇付支付</el-checkbox>
							<el-checkbox label="9">云资金-中信支付</el-checkbox>
							<el-checkbox label="11">B2b门店助手-微信支付</el-checkbox>
							<el-checkbox label="12">B2b门店助手-银行转账</el-checkbox>
							<el-checkbox label="13">云资金-网商收银台</el-checkbox>
							<el-checkbox label="14">拉卡拉全渠道-余额支付</el-checkbox>
							<el-checkbox label="16">拉卡拉钱包余额</el-checkbox>
							<!-- // TODO 过滤拉卡拉全渠道-收银台 -->
<!--							<el-checkbox label="15">拉卡拉全渠道-收银台</el-checkbox>-->
							<!-- <el-checkbox label="10">云资金-富友账户通支付</el-checkbox> -->
						</el-checkbox-group>
						<el-checkbox-group class="pay-type-box" style="margin-top:15px" v-model="payTypeRadio2" v-if="payWayRadio === '2'">
							<!-- <el-checkbox label="0">不限</el-checkbox> -->
							<el-checkbox label="0">线下支付</el-checkbox>
							<el-checkbox label="2">微信支付</el-checkbox>
							<el-checkbox label="4">预付货款</el-checkbox>
							<el-checkbox label="6">微企付</el-checkbox>
							<el-checkbox label="7">云资金-网商余额支付</el-checkbox>
							<el-checkbox label="8">云资金-汇付支付</el-checkbox>
							<el-checkbox label="9">云资金-中信支付</el-checkbox>
							<el-checkbox label="11">B2b门店助手-微信支付</el-checkbox>
							<el-checkbox label="12">B2b门店助手-银行转账</el-checkbox>
							<el-checkbox label="13">云资金-网商收银台</el-checkbox>
							<el-checkbox label="14">拉卡拉全渠道-余额支付</el-checkbox>
							<el-checkbox label="16">拉卡拉钱包余额</el-checkbox>
							<!-- // TODO 过滤拉卡拉全渠道-收银台 -->
<!--							<el-checkbox label="15">拉卡拉全渠道-收银台</el-checkbox>-->
							<!-- <el-checkbox label="10">云资金-富友账户通支付</el-checkbox> -->
						</el-checkbox-group>
					</div>
				</div>
				<div class="input-box" v-if="lineSelect === '3'">
					<div class="change-title">修改为</div>
					<div class="change-right">
						<div class="pay-type-box">
							<el-radio v-if="AuthorityList['03_0001_0008_00']" v-model="status" label="0">启用</el-radio>
							<el-radio v-if="AuthorityList['03_0001_0009_00']" v-model="status" label="1">停用</el-radio>
						</div>
					</div>
				</div>
				<div class="input-box" v-if="lineSelect === '18'">
					<div class="change-title">修改为</div>
					<div class="change-right">
						<div class="pay-type-box">
							<el-radio v-model="invoiceFlag" :label="1">允许</el-radio>
							<el-radio v-model="invoiceFlag" :label="0">不允许</el-radio>
						</div>
					</div>
				</div>
				<div class="input-box" v-if="lineSelect === '6'">
					<div class="change-title">修改为</div>
					<div class="change-right">
						<div class="pay-type-box" style="width: 180px;">
							<el-input size="mini" onkeyup="value=value.replace(/[^0-9.]/g,'')" @input='checkNum(creditline)' v-model="creditline" placeholder="请输入信用额度" :maxlength="10">
								<template slot="prepend">￥</template>
							</el-input>
						</div>
					</div>
				</div>
				<div class="input-box" v-if="lineSelect === '7'">
					<div class="change-title">修改为</div>
					<div class="change-right">
						<div class="">
							<el-radio v-model="creditlineflag" :label="0">不使用信用额度</el-radio>
							<el-radio v-model="creditlineflag" :label="1">使用信用额度</el-radio>
						</div>
					</div>
				</div>
				<div v-show="lineSelect === '8'">
					<div style="display: flex;align-items: center;height: 40px;">
						<div>
							适用门店：
						</div>
						<el-radio style="height: 20px;line-height: 20px;" v-model="relAllShopFlag" :label="1">全部门店</el-radio>
						<el-radio style="height: 20px;line-height: 20px;" v-model="relAllShopFlag" :label="0">自定义门店</el-radio>
						<div  v-if="relAllShopFlag === 0" @click="bindShopClick" style="height: 20px;line-height: 20px;margin-left:10px;color:var(--fx-primary-color);cursor: pointer;font-size: 12px;">
							<i style="font-size: 14px;" class="el-icon-circle-plus"></i>
							选择门店
						</div>
					</div>
					<div v-if="relAllShopFlag === 0" style="display: flex;align-items: center;height: 40px;">
						<div>
							已选：
						</div>
						<div>{{shopText}}</div>
					</div>
				</div>
				<div class="input-box" v-if="lineSelect === '9'">
					<div class="change-title">修改为</div>
					<div class="change-right">
						<div class="pay-type-box">
							<el-radio v-model="hiddenPriceFlag" label="0">显示</el-radio>
							<div style="display: flex;margin-top: 10px;align-items: center;">
								<el-radio v-model="hiddenPriceFlag" label="1">隐藏</el-radio>
								<span v-if="hiddenPriceFlag === '1'" style="color: red;margin-left: 10px;">*设置隐藏的客户【客户门店支付设置】中选择的支付方式需包括线下支付，否则客户无法下单</span>
							</div>
						</div>
					</div>
				</div>
				<div class="input-box" v-if="lineSelect === '10'">
					<div class="change-title" style="width:62px"></div>
					<div class="change-right" style="color:red">
						注：如果同步了中台专用价格档案，则删除不生效。如需删除请前去‘云供应链-价格档案’操作！
					</div>
				</div>
				<div class="input-box" v-if="lineSelect === '12'">
					<div class="change-title">修改为</div>
					<div class="change-right">
						<el-input style="width:180px" type="textarea" v-model="appendixOne" size='mini' maxlength="100" placeholder="附录1"></el-input>
					</div>
				</div>
				<div class="input-box" v-if="lineSelect === '13'">
					<div class="change-title">修改为</div>
					<div class="change-right">
						<el-input style="width:180px" type="textarea" v-model="appendixTwo" size='mini' maxlength="100" placeholder="附录2"></el-input>
					</div>
				</div>
				<div class="input-box" v-if="lineSelect === '14'">
					<div class="change-title">修改为</div>
					<div class="change-right">
						<div class="pay-type-box">
							<el-radio v-if="AuthorityList['03_0001_0008_00']" v-model="friendpay" label="1">开启好友代付</el-radio>
							<el-radio v-if="AuthorityList['03_0001_0009_00']" v-model="friendpay" label="0">关闭好友代付</el-radio>
						</div>
					</div>
				</div>
				<div class="input-box" v-if="lineSelect === '15'">
					<div class="change-title">修改为</div>
					<div class="change-right">
						<div class="pay-type-box">
							<div class="table-row" v-for="item in paymodeList" :key="item.paymode">
								<span style="width:50%;">{{ item.name }}</span>
								<el-select v-model="item.mode" :disabled="isDisabled || item.disabled" collapse-tags class="select-box2" size='mini' placeholder="请选择退货方式">
									<el-option value="0" label="原路返回"></el-option>
									<el-option value="1" label="退回预付货款" v-if="!item.disabled"></el-option>
								</el-select>
							</div>
						</div>
					</div>
				</div>
				<div class="input-box" style="align-items: flex-start" v-if="lineSelect === '16'">
					<div class="change-title">修改为</div>
					<div class="change-right" style="border:1px solid #333; padding: 10px">
						<div class="pay-type-box">
							<div class="table-row">
								<span style="width:50%;">最小金额限制</span>
								<el-input
									:disabled="isDisabled"
									@blur="minBuyMoneyBlur"
									type='text'
									v-model="minBuyMoney"
									size='mini'
									@mousewheel.native.prevent></el-input>
							</div>
							<div class="table-row">
								<span style="width:50%;">最大金额限制</span>
								<el-input
									:disabled="isDisabled"
									@blur="maxBuyMoneyBlur"
									type='text'
									v-model="maxBuyMoney"
									size='mini'
									@mousewheel.native.prevent></el-input>
							</div>
						</div>
					</div>
				</div>
				<div class="input-box" v-if="lineSelect === '17'">
					<div class="change-title">修改为</div>
					<div class="change-right customer-category-wrapper">
						<div class="pay-type-box">
								<el-select v-model="customerCategoryId" class="select-box2" size='mini' placeholder="请选择类别" @change="choseCustomerCategory" clearable filterable>
									<el-option v-for="item in customerList" :value="item.ccid" :label="item.ccname" :key="item.ccid"></el-option>
								</el-select>
						</div>
						<div class="customer-category-error" v-if="customerCategoryError">客户类别为必填</div>
					</div>
				</div>
				<div style="margin-top:40px;margin-left:70px;" v-if="lineSelect === '14'">提示:如客户关联店铺未绑定MCID，客户的好友代付功能不生效！</div>
				<div class="btn-box" style="margin-top:30px;">
					<el-button size="small" class="btn" plain type="primary" @click="cancelLine">取消</el-button>
					<el-button size="small" class="btn" plain type="primary" v-if="lineSelect === '1'" @click="savePaytype">确认</el-button>
					<el-button size="small" class="btn" plain type="primary" v-if="lineSelect === '2'" @click="saveMultiLevel">确认</el-button>
					<el-button size="small" class="btn" plain type="primary" v-if="lineSelect === '3'" @click="saveStatus">确认</el-button>
					<el-button size="small" class="btn" plain type="primary" v-if="lineSelect === '4'" @click="deleteList">确认</el-button>
					<el-button size="small" class="btn" plain type="primary" v-if="lineSelect === '0'" @click="saveLine">确认</el-button>
					<el-button size="small" class="btn" plain type="primary" v-if="lineSelect === '5'" @click="pushClick">确认</el-button>
					<el-button size="small" class="btn" plain type="primary" v-if="lineSelect === '6'" @click="saveCreditLine">确认</el-button>
					<el-button size="small" class="btn" plain type="primary" v-if="lineSelect === '7'" @click="saveUseLimit">确认</el-button>
					<el-button size="small" class="btn" plain type="primary" v-if="lineSelect === '8'" @click="saveBatchShop">确认</el-button>
					<el-button size="small" class="btn" plain type="primary" v-if="lineSelect === '9'" @click="saveBatchHiddenPrice">确认</el-button>
					<el-button size="small" class="btn" plain type="primary" v-if="lineSelect === '10'" @click="deletePriceList">确认</el-button>
					<el-button size="small" class="btn" plain type="primary" v-if="lineSelect === '11'" @click="deleteRelationList">确认</el-button>
					<el-button size="small" class="btn" plain type="primary" v-if="lineSelect === '12'" @click="saveAppendix(1)">确认</el-button>
					<el-button size="small" class="btn" plain type="primary" v-if="lineSelect === '13'" @click="saveAppendix(2)">确认</el-button>
					<el-button size="small" class="btn" plain type="primary" v-if="lineSelect === '14'" @click="otherPay">确认</el-button>
					<el-button size="small" class="btn" plain type="primary" v-if="lineSelect === '15'" @click="returnPaymode">确认</el-button>
					<el-button size="small" class="btn" plain type="primary" :disabled="saveDisable" v-if="lineSelect === '16'" @click="savePrice">确认</el-button>
					<el-button size="small" class="btn" plain type="primary" v-if="lineSelect === '17'" @click="savecustomerCategory">确认</el-button>
					<el-button size="small" class="btn" plain type="primary" v-if="lineSelect === '18'" @click="saveInvoiceFlag">确认</el-button>
				</div>
				<div style="margin-top:10px;margin-left:70px;color:red" v-if="lineSelect === '16'">提示:客户订货最小金额限制不得大于客户最大订货金额限制，否则无法提交</div>
			</div>
		</el-dialog>
		<el-dialog title="会员等级管理" class="dialog-title1" :visible.sync="levelModal" width='600px' @open='levelOpen' :close-on-click-modal="false">
			<div style="text-align: left;margin: 10px 0;">
				<el-button size='small' type="primary" style="" plain class='fx-big-btn' @click="addBarcode">新增</el-button>
			</div>
			<div class="bar-wrap">
				<div class="bar-box" v-for="(item, index) in newLevelData" :key="index">
					<div class="bar-content">
						<div style="width:100px;margin-right:20px">{{item.level !== 0 ? item.levelName : ''}}</div>
						<el-input style="width:250px;" type="text" placeholder="最多输入8个字" @input="levelChange(index)" size='mini' maxlength="8" v-model='item.customerlevelname'></el-input>
					</div>
					<div class="bar-delete" @click="deleteNew(index)">删除</div>
				</div>
				<!-- <div v-for="(item, index) in levelList" :key="item.customerlevelid">
					<div class="bar-box">
						<div class="bar-content">
							<div>{{item.customerlevelname}}</div>
						</div>
						<div class="bar-delete" @click="deleteOld(item.customerlevelid, index)">删除</div>
					</div>
				</div> -->
			</div>
			<div class="valet-foot">
				<el-button class="btn fx-big-btn" plain type="primary" size='small' @click="closeLevel">取消</el-button>
				<el-button class="btn fx-big-btn" plain type="primary" size='small' @click="saveLevel">保存</el-button>
			</div>
		</el-dialog>
		<el-dialog title="提示" class="confirm-dialog" top='60px' :visible.sync="errorMsgModel" width='500px' :close-on-click-modal="false">
			<div style="margin-bottom:10rpx;max-height:350px;overflow:auto">
				<div class="errormsgText" v-for="(item,index) in errorMsgList" :key='index' >
					{{item}}
				</div>
			</div>
			<div style="width:100%;text-align: center;margin-top:10px">
				<el-button size="small" style="width: 120px;" plain type="primary" @click="errorMsgClick">确认</el-button>
			</div>
		</el-dialog>
		<el-dialog class="confirm-dialog2" top='160px' :visible.sync="progressModal" width='400px' :close-on-click-modal="false">
			<!-- <div class="dialog-box">
				<div class="title">客户导入中</div>
				<el-progress type="circle" :percentage="10"></el-progress>
				<div class="tips1">正在同步，请稍等...</div>
				<div class="tips2">过程中请勿操作此页面，防止同步失败</div>
			</div> -->
			<Progress
				:progressModal.sync='progressModal'
				v-if='progressModal'
				:keyWord='keyWord'
				@reload='reload'
				@inportCustomDialogModel='inportCustomDialogModel'
				@resultMsg='resultMsg'
			></Progress>
		</el-dialog>
		<el-dialog :title="dialogTitle" class="confirm-dialog" top='160px' :visible.sync="inportCustomModel" width='466px' :close-on-click-modal="false">
			<div class="dialog-box" v-if="dialogTitle === '客户导入'">
				<div class="dialog-container">
					<div class="item">
						<img src="~/images/icon/success.png" alt="">
						<span>同步更新成功 <i style="font-weight: bold;">{{successCount ? successCount : 0}}</i>个 客户</span>
					</div>
					<div class="item">
						<img src="~/images/icon/error.png" alt="">
						<span>同步更新失败 <i style="font-weight: bold;">{{errorCount ? errorCount : 0}}</i>个 客户</span>
						<!-- <span class="search-btn" @click="searchFailData" v-if="errorCount">查看失败数据</span> -->
						<span class="search-btn" @click="searchFailData">查看失败数据</span>
					</div>
				</div>
				<div style="width:100%;text-align: center;margin: 50px 0 15px 0;">
					<el-button size="small" style="width: 72px;height: 32px;" type="primary" @click="inportCustomClick">完成</el-button>
				</div>
			</div>
			<div style="margin-bottom:10rpx;max-height:250px;overflow:auto" v-if="dialogTitle === '客户导入失败数据'">
				<div class="errormsgText" v-for="(item,index) in failDataList" :key='index'>
					{{item}}
				</div>
				<div style="width:100%;text-align: center;margin: 50px 0 15px 0;">
					<el-button size="small"
						style="width: 72px;height: 32px;"
						type="primary"
						v-clipboard:copy="failDataList"
						v-clipboard:success="onCodeCopy"
						v-clipboard:error="onCodeError"
					>复制</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog
			top='100px'
			title="选择适用门店"
			class="dialog-title"
			:visible.sync="shopDialog"
			width="780px"
			append-to-body
			:close-on-click-modal="false">
			<div>
				<bindShop v-if="shopDialog" :customerDialog.sync='shopDialog' :chooseData1='chooseShop' @reloadCus='reloadShop'></bindShop>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { cityData } from '@/js/location/city.js'
import { provinceData } from '@/js/location/province.js'
import { geography } from '@/js/location/geography.js'
import { areaData } from '@/js/location/areaData.js'
import bindShop from '@/components/bindShop/bindShop.vue'
import Progress from '@/components/progress/importCustomer.vue'
export default {
	name: 'table-box',
	components: {
		bindShop,
		Progress
	},
	props: {
		id: String
	},
	data () {
		return {
			saveDisable: false,
			keyWord: '',
			shopText: '',
			chooseShop: [],
			shopDialog: false,
			relAllShopFlag: 1,
			status: '0',
			invoiceFlag: 1,
			index: 1,
			params: {},
			errorMsgModel: false,
			errorMsgList: [],
			ListStaffid: '',
			codeNumber: 0,
			waring: false,
			addCodeListModel: false,
			multiSetModel: false,
			levelModal: false,
			isDisabled: true,
			collapse: true,
			tableHeight: '100%',
			name: '',
			invitationcode: '',
			activationflag: '',
			code: '',
			syscode: '',
			account: '',
			keyword: '',
			lineValue: '',
			levelValue: '',
			tel: '',
			customerlevelid: '',
			customertagid: '',
			area: '0',
			province: '',
			city: '',
			district: '',
			email: '',
			disabledflag: 0,
			page: {
				size: 20,
				num: 1
			},
			total: null,
			tableData: [],
			staffList: [],
			staffid: '',
			fixLineList: [],
			lineList: [],
			selectLineList: [],
			fixLevelList: [],
			levelList: [],
			selectLevelList: [],
			tagList: [],
			// ids: [],
			newLevelData: [],
			delList: [],
			provinceListTotal: [],
			provinceList: [],
			cityList: [],
			areaList: [],
			districtList: [],
			AuthorityList: {
				'03_0001_0001_00': false,
				'03_0001_0002_00': false,
				'03_0001_0003_00': false,
				'03_0001_0004_00': false,
				'03_0001_0005_00': false,
				'03_0001_0006_00': false,
				'03_0001_0007_00': false,
				'03_0001_0008_00': false,
				'03_0001_0009_00': false,
				'03_0001_0010_00': false,
				'03_0001_0011_00': false,
				'03_0001_0012_00': false,
				'03_0001_0013_00': false
			},
			lineSelect: '0',
			lineRadio: '1',
			levelRadio: '1',
			payWayRadio: '1',
			payTypeRadio: [],
			payTypeRadio2: [],
			uploadFlag: '',
			matchbillcenterflag: false,
			matchbillcenterpriceflag: 1,
			creditline: '',
			creditlineflag: 0,
			creditFlag: -1,
			creditlinetype: 0,
			mincreditline: '',
			maxcreditline: '',
			tableSelectUtils: this.$fxUtils.tableSelectUtils({
				key: 'customerid',
				selectHandler: this.tableSelectUtilsHandler
			}),
			dialogTitle: '',
			progressModal: false,
			inportCustomModel: false,
			successCount: 0,
			errorCount: 0,
			failDataList: [],
			shopNameIds: [],
			shopList: [],
			hiddenPriceFlag: '0',
			appendixOne: '',
			appendixTwo: '',
			friendpay: -1,
			wechatPaymodes: '0',
			payModesFlag: '0',
			tenpayflag: '0',
			openflag: '1',
			maxBuyMoney: '',
			minBuyMoney: '',
			b2bWechatFlag: '0',
			b2bBankFlag: '0',
			customerList: [],
			customerCategoryId: '',
			customerCategoryName: '',
			customerCategoryError: false,
			paymodeList: [{
				paymode: 2,
				mode: '0',
				name: '微信支付',
				disabled: false
			}, {
				paymode: 0,
				mode: '0',
				name: '线下支付',
				disabled: true
			}, {
				paymode: 4,
				mode: '0',
				name: '预付货款支付',
				disabled: true
			}, {
				paymode: 6,
				mode: '1',
				name: '微企付支付',
				disabled: false
			}, {
				paymode: 7,
				mode: '0',
				name: '云资金-网商余额支付',
				disabled: true
			}, {
				paymode: 8,
				mode: '0',
				name: '云资金-汇付支付',
				disabled: true
			}, {
				paymode: 9,
				mode: '0',
				name: '云资金-中信支付',
				disabled: true
			}, {
				paymode: 10,
				mode: '0',
				name: '云资金-富友账户通支付',
				disabled: true
			}, {
				paymode: 11,
				mode: '0',
				name: 'B2b门店助手-微信支付',
				disabled: false
			}, {
				paymode: 12,
				mode: '0',
				name: 'B2b门店助手-银行转账',
				disabled: false
			}, {
				paymode: 13,
				mode: '0',
				name: '云资金-网商收银台',
				disabled: true
			}, {
				paymode: 14,
				mode: '0',
				name: '拉卡拉全渠道-余额支付',
				disabled: true
			// }, {
			// 	paymode: 15,
			// 	mode: '0',
			// 	name: '拉卡拉全渠道-收银台',
			// 	disabled: true
			}, {
				paymode: 16,
				mode: '0',
				name: '拉卡拉钱包余额',
				disabled: true
			}]
		}
	},
	computed: {
		ids () {
			return this.tableSelectUtils.getSelectRows()
		}
	},
	watch: {
		id: {
			handler (val) {
				this.getAuthority('03_0001_0000_00')
				let a = window.sessionStorage.getItem('customerSelect')
				if (a) {
					a = JSON.parse(a)
					this.name = a.name
					this.code = a.code
					this.syscode = a.syscode
					this.keyword = a.keyword
					this.staffid = a.staffid
					this.activationflag = a.activationFlag
					this.invitationcode = a.invitationCode
					this.page.size = a.size
					this.page.num = a.page
				}
				this.tableReload()
				this.getStaffList()
				this.getLineList()
				this.getLevelList()
				this.gettagList()
				this.getCustomer()
			},
			immediate: true
		}
	},
	created () {
		this.checkSmallCategory()
		this.getShopList()
		this.provinceListTotal = provinceData.RECORDS
		this.provinceList = provinceData.RECORDS
		this.areaList = geography
	},
	methods: {
		checkPrice () {
			if ((this.minBuyMoney !== '' && this.maxBuyMoney !== '') && (+this.minBuyMoney > +this.maxBuyMoney)) {
				this.saveDisable = true
			} else {
				this.saveDisable = false
			}
		},
		maxBuyMoneyBlur () {
			if (this.maxBuyMoney === '') {
			} else {
				this.maxBuyMoney = this.$fxUtils.toFixedSHW(this.maxBuyMoney, 2)
				if (this.maxBuyMoney > 5000000) {
					this.maxBuyMoney = '5000000.00'
				}
				if (this.maxBuyMoney < 0) {
					this.maxBuyMoney = '0.00'
				}
			}
			this.checkPrice()
		},
		minBuyMoneyBlur () {
			if (this.minBuyMoney === '') {
			} else {
				this.minBuyMoney = this.$fxUtils.toFixedSHW(this.minBuyMoney, 2)
				if (this.minBuyMoney > 5000000) {
					this.minBuyMoney = '5000000.00'
				}
				if (this.minBuyMoney < 0) {
					this.minBuyMoney = '0.00'
				}
			}
			this.checkPrice()
		},
		reloadShop (data) {
			this.chooseShop = data.chooseData
			this.shopText = data.shopText
			this.shopDialog = false
		},
		bindShopClick () {
			this.shopDialog = true
		},
		// 是否对接中台
		checkSmallCategory () {
			// return new Promise((resolve, reject) => {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.matchbillcenterflag = res.matchbillcenterflag
				this.matchbillcenterpriceflag = res.matchbillcenterpriceflag
			})
			// })
		},
		pushClick () {
			let tableList = this.tableData
			let list = this.ids
			let arr = []
			list.forEach(item => {
				tableList.forEach(tableItem => {
					if (item.customerid === tableItem.customerid) {
						let row = {
							customercategoryid: tableItem.customerCategoryId,
							customercategoryname: tableItem.customerCategoryName,
							id: tableItem.customerid,
							name: tableItem.customerName,
							syscodeid: tableItem.syscodeid,
							syscode: tableItem.syscode,
							linktel: tableItem.linktel ? tableItem.linktel : '',
							linkman: tableItem.linkman ? tableItem.linkman : '',
							email: tableItem.email ? tableItem.email : ''
						}
						arr.push(row)
					}
				})
			})
			let customerNames = this.ids.map(e => {
				return e.name
			}).join(',')
			let changeData = {
				pre: { lineSelect5: { type: '1' } },
				cur: { lineSelect5: { type: '2', customerName: customerNames } }
			}
			const logger = this.$fxLogger.createInfo('custom.custom-file.update', changeData)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/pushCustomerToBillCenter`,
				data: arr,
				logger
			}).then(res => {
				if (res.result === true) {
					this.tableSelectUtils.clear()
					this.multiSetModel = false
					this.$message.success('操作成功！')
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		saveBatchShop () {
			if (this.chooseShop.length === 0 && this.relAllShopFlag === 0) {
				this.$message.error('请选择适用店铺')
				return false
			}
			let list = this.ids.map(item => {
				return item.id
			})
			let params = {
				customerIds: list,
				relShopIdList: this.chooseShop,
				relAllsShopFlag: this.relAllShopFlag === 1
			}
			let customerNames = this.ids.map(e => {
				return e.name
			}).join(',')
			let changeData = {
				pre: { lineSelect8: { type: '1' } },
				cur: { lineSelect8: { type: '2', customerName: customerNames, flag: this.relAllShopFlag, name: this.shopText } }
			}
			const logger = this.$fxLogger.createInfo('custom.custom-file.update', changeData)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/bindShop`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.tableSelectUtils.clear()
					this.multiSetModel = false
					this.$message.success('批量设置适用门店成功！')
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		saveUseLimit () {
			let list = this.ids
			// console.log(list)
			let params = {
				customerIds: [],
				creditlineflag: this.creditlineflag
			}
			list.forEach(item => {
				params.customerIds.push(item.customerid)
			})
			let customerNames = this.ids.map(e => {
				return e.name
			}).join(',')
			let flag = this.creditlineflag === 0 ? '不使用信用额度' : '使用信用额度'
			let changeData = {
				pre: { lineSelect7: { type: '1' } },
				cur: { lineSelect7: { type: '2', customerName: customerNames, flag: flag } }
			}
			const logger = this.$fxLogger.createInfo('custom.custom-file.update', changeData)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/batch/creditlineflag`,
				data: params,
				logger
			}).then(res => {
				if (res.result === true) {
					this.tableSelectUtils.clear()
					this.multiSetModel = false
					this.tableReload()
					this.$message.success('操作成功！')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		saveCreditLine () {
			if (+this.creditline < 0 || +this.creditline > 9999999.99) {
				this.$message.error('请设置0~9999999.99范围内的信用额度！')
				return false
			}
			let list = this.ids
			let params = {
				customerIds: [],
				creditline: this.creditline
			}
			list.forEach(item => {
				params.customerIds.push(item.customerid)
			})
			let customerNames = this.ids.map(e => {
				return e.name
			}).join(',')
			let changeData = {
				pre: { lineSelect6: { type: '1' } },
				cur: { lineSelect6: { type: '2', customerName: customerNames, money: this.creditline } }
			}
			const logger = this.$fxLogger.createInfo('custom.custom-file.update', changeData)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/batch/creditline`,
				data: params,
				logger
			}).then(res => {
				if (res.result === true) {
					this.tableSelectUtils.clear()
					this.multiSetModel = false
					this.tableReload()
					this.$message.success('操作成功！')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		saveBatchHiddenPrice () {
			let list = this.ids
			let params = {
				customerIds: [],
				hiddenPriceFlag: this.hiddenPriceFlag
			}
			if (this.hiddenPriceFlag === '1') {
				params.hiddenPriceFlag = true
			} else {
				params.hiddenPriceFlag = false
			}
			list.forEach(item => {
				params.customerIds.push(item.customerid)
			})
			let customerNames = this.ids.map(e => {
				return e.name
			}).join(',')
			let flag = this.hiddenPriceFlag === '0' ? '显示' : '隐藏'
			let changeData = {
				pre: { lineSelect9: { type: '1' } },
				cur: { lineSelect9: { type: '2', customerName: customerNames, flag: flag } }
			}
			const logger = this.$fxLogger.createInfo('custom.custom-file.update', changeData)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/hiddenPriceFlag/save`,
				data: params,
				logger
			}).then(res => {
				if (res.result === true) {
					this.tableSelectUtils.clear()
					this.multiSetModel = false
					this.tableReload()
					this.$message.success('操作成功！')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		saveStatus () {
			if (this.status === '0') {
				this.unDisableClick()
			} else {
				this.disableClick()
			}
		},
		saveInvoiceFlag () {
			if (this.ids.length === 0) {
				this.$message.error('请至少选择一个客户！')
				return false
			}
			let customerNames = this.ids.map(e => {
				return e.name
			}).join(',')
			const statusText = this.invoiceFlag === 1 ? '允许' : '不允许'
			let changeData = {
				pre: { lineSelect18: { type: '1' } },
				cur: { lineSelect18: { type: '2', customerName: customerNames, status: `${statusText}` } }
			}
			const logger = this.$fxLogger.createInfo('custom.custom-file.update', changeData)
			let params = {
				customerIds: this.ids.map(e => { return e.customerid }),
				invoiceFlag: this.invoiceFlag
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/batchInvoiceFlag`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.tableSelectUtils.clear()
					this.multiSetModel = false
					this.$message.success('修改成功')
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		// 新增
		addLevel () {
			this.levelModal = true
		},
		closeLevel () {
			this.levelModal = false
		},
		addBarcode () {
			let numArr = this.newLevelData.map(item => {
				return item.level
			})
			let index = 1
			let flag = true
			if (numArr.length > 0) {
				for (let i = 1; i < (numArr.length + 2); i++) {
					let isHave = numArr.includes(i)
					if (flag && !isHave) {
						index = i
						flag = false
					}
				}
			}
			let add = { customerlevelname: '', level: index, levelName: 'vip' + index, customerlevelid: '' }
			this.newLevelData.push(add)
			this.newLevelData = this.newLevelData.sort(this.compare('level'))
		},
		compare (property) {
			return (a, b) => {
				var value1 = a[property]
				var value2 = b[property]
				return value1 - value2
			}
		},
		levelOpen () {
			// this.levelList = this.fixLevelList
			this.newLevelData = this.fixLevelList
			this.delList = []
		},
		levelChange (index) {
			this.newLevelData[index].customerlevelname = this.newLevelData[index].customerlevelname.trim()
			this.newLevelData[index].customerlevelname = this.newLevelData[index].customerlevelname.replace(/[',\\]/g, '')
		},
		deleteNew (index) {
			let id = this.newLevelData[index].customerlevelid
			if (id !== '') {
				this.delList.push({ 'id': id })
			}
			this.newLevelData.splice(index, 1)
		},
		saveLevel () {
			let addArr = []
			let oldArr = []
			this.newLevelData.forEach(item => {
				item.id = item.customerlevelid
				item.aliasName = item.customerlevelname
				if (item.id === '') {
					addArr.push(item)
				} else {
					oldArr.push(item)
				}
			})
			let params = {
				addCustomerLevelList: addArr,
				updateCustomerLevelList: oldArr,
				removeCustomerLevelList: this.delList
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/saveOrDelCustomerLevel`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.levelModal = false
					this.getLevelList()
					this.selectLevelList = []
					this.delList = []
					this.$message.success('保存成功')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		provinceChange () {
			this.cityList = []
			this.districtList = []
			this.city = ''
			this.district = ''
			let a = cityData.RECORDS
			for (let i = 0; i < a.length; i++) {
				if (this.province === a[i].pid) {
					this.cityList.push(a[i])
				}
			}
		},
		cityChange () {
			let province = this.province
			let city = this.city
			this.districtList = []
			this.district = ''
			for (let i = 0; i < areaData.length; i++) {
				if (province === areaData[i].code) {
					for (let j = 0; j < areaData[i].child.length; j++) {
						if (city === areaData[i].child[j].code) {
							this.districtList = areaData[i].child[j].child
						}
					}
				}
			}
		},
		areaChange (e) {
			this.city = ''
			this.province = ''
			this.district = ''
			this.provinceList = []
			this.cityList = []
			this.districtList = []
			if (e === '0') {
				this.provinceList = this.provinceListTotal
			} else {
				let a = this.provinceListTotal
				for (let i = 0; i < a.length; i++) {
					if (a[i].areacode === this.area) {
						this.provinceList.push(a[i])
					}
				}
			}
		},
		privateClick1 () {
			let url = 'https://fxscms.oss-cn-beijing.aliyuncs.com/sharego/business/qshop/customers/product/私密商品导入模版.xlsx?timeStamp=' + new Date().getTime()
			window.location.href = url
		},
		privateClick () {
			this.uploadFlag = '2'
			this.$refs.file.dispatchEvent(new MouseEvent('click'))
		},
		fileClick () {
			this.uploadFlag = '0'
			this.$refs.file.dispatchEvent(new MouseEvent('click'))
		},
		errorMsgClick () {
			this.errorMsgModel = false
		},
		inportCustomClick () {
			this.inportCustomModel = false
		},
		searchFailData () {
			this.dialogTitle = '客户导入失败数据'
		},
		// copyCustomNumber () {
		// 	this.failDataList.forEach(item => {
		// 		this.numberList.push(item)
		// 	})
		// 	console.log(this.numberList)
		// },
		onCodeCopy (e) {
			this.$message.success('复制成功！')
		},
		onCodeError (e) {
			this.$message.error('复制失败！')
		},
		getFile (e) {
			// let files = e.target.files[0]
			// console.log(files)
			if (this.uploadFlag === '0') {
				this.uploadExcelHandle()
			} else if (this.uploadFlag === '1') {
				this.uploadCustomHandle()
			} else {
				this.uploadPrivateHandle()
			}
			this.$refs.file.value = ''
		},
		uploadPrivateHandle () {
			return new Promise((resolve, reject) => {
				var formData = new FormData()
				formData.append('file', this.$refs.file.files[0])
				this.$store.dispatch('requestFilePost', {
					url: `${this.$fxBaseApi.newExportUrl}/customer/importCustomerProductExcel`,
					data: formData
				}).then(res => {
					if (res.result) {
						this.$message.success('导入成功！')
						this.tableReload()
					} else {
						this.errorMsgList = res.data
						this.errorMsgModel = true
					}
				})
			})
		},
		uploadExcelHandle () {
			return new Promise((resolve, reject) => {
				var formData = new FormData()
				formData.append('file', this.$refs.file.files[0])
				this.$store.dispatch('requestFilePost', {
					url: `${this.$fxBaseApi.newExportUrl}/customer/importCustomerPriceExcel?syscodeid=` + 0,
					data: formData
				}).then(res => {
					if (res.result) {
						this.$message.success('导入成功！')
						this.tableReload()
					} else {
						this.errorMsgList = res.data
						this.errorMsgModel = true
					}
				})
			})
		},
		listExport () {
			let params = this.params
			if (this.ids.length !== 0) {
				let list = this.ids
				let data = []
				for (let i = 0; i < list.length; i++) {
					data.push(list[i].customerid)
				}
				params.customerIds = data
			} else {
				params.customerIds = []
			}
			const req = new XMLHttpRequest()
			let _this = this
			req.open('POST', `${this.$fxBaseApi.newExportUrl}/customer/export`, true)
			req.responseType = 'blob'
			req.setRequestHeader('Content-Type', 'application/json')
			req.setRequestHeader('pname', 'bc2ff5388144d30e137b28acafd39795')
			req.setRequestHeader('shiroSession', window.sessionStorage.getItem('shiroSession'))
			req.onload = function () {
				const data = req.response
				const blob = new Blob([data])
				const blobUrl = window.URL.createObjectURL(blob)
				_this.download(blobUrl, 2)
			}
			req.send(JSON.stringify(params))
		},
		listInport () {
			this.uploadFlag = '1'
			this.$refs.file.dispatchEvent(new MouseEvent('click'))
		},
		uploadCustomHandle () {
			return new Promise((resolve, reject) => {
				var formData = new FormData()
				formData.append('file', this.$refs.file.files[0])
				this.$store.dispatch('requestFilePost', {
					url: `${this.$fxBaseApi.newExportUrl}/customer/importCustomer`,
					data: formData
				}).then(res => {
					if (res.result) {
						this.keyWord = 'customerImpExcel'
						this.progressModal = true
						// this.$message.success('导入成功！')
						this.dialogTitle = '客户导入'
						// this.failDataList = res.data.errList
						// this.successCount = res.data.successCount
						// this.errorCount = res.data.errorCount
						// this.inportCustomModel = true
						// this.tableReload()
					} else {
						this.$message.error(res.msg)
						// this.dialogTitle = '客户导入'
						// this.failDataList = res.data.errList
						// this.successCount = res.data.successCount
						// this.errorCount = res.data.errorCount
						// this.inportCustomModel = true
						// this.errorMsgList = res.data
						// this.errorMsgModel = true
					}
				})
			})
		},
		inportCustomDialogModel (val) {
			this.inportCustomModel = val
		},
		resultMsg (val) {
			this.failDataList = val.errList
			this.successCount = val.successCount
			this.errorCount = val.errorCount
			console.log(this.failDataList)
		},
		privateDownloadClick () {
			let params = this.params
			if (this.ids.length !== 0) {
				let list = this.ids
				let data = []
				for (let i = 0; i < list.length; i++) {
					data.push(list[i].customerid)
				}
				params.customerIds = data
			} else {
				params.customerIds = []
			}
			const req = new XMLHttpRequest()
			let _this = this
			req.open('POST', `${this.$fxBaseApi.newExportUrl}/customer/exportBatchCustomerProductExcel`, true)
			req.responseType = 'blob'
			req.setRequestHeader('Content-Type', 'application/json')
			req.setRequestHeader('pname', 'bc2ff5388144d30e137b28acafd39795')
			req.setRequestHeader('shiroSession', window.sessionStorage.getItem('shiroSession'))
			req.onload = function () {
				const data = req.response
				const blob = new Blob([data])
				const blobUrl = window.URL.createObjectURL(blob)
				_this.privateDownload(blobUrl, 1)
			}
			req.send(JSON.stringify(params))
		},
		privateDownload (blobUrl, num) {
			const a = document.createElement('a')
			a.style.display = 'none'
			var date = new Date()
			var year = date.getFullYear()
			var month = date.getMonth() + 1
			var day = date.getDate()
			let name = '客户与商品关系详情(' + year + '-' + month + '-' + day + ').xlsx'
			a.download = name
			a.href = blobUrl
			a.click()
		},
		downloadClick () {
			let params = this.params
			if (this.ids.length !== 0) {
				let list = this.ids
				let data = []
				for (let i = 0; i < list.length; i++) {
					data.push(list[i].syscodeid)
				}
				params.customerIds = data
			} else {
				params.customerIds = []
			}
			const req = new XMLHttpRequest()
			let _this = this
			req.open('POST', `${this.$fxBaseApi.newExportUrl}/customer/exportCustomerPriceExcel`, true)
			req.responseType = 'blob'
			req.setRequestHeader('Content-Type', 'application/json')
			req.setRequestHeader('pname', 'bc2ff5388144d30e137b28acafd39795')
			req.setRequestHeader('shiroSession', window.sessionStorage.getItem('shiroSession'))
			req.onload = function () {
				const data = req.response
				const blob = new Blob([data])
				const blobUrl = window.URL.createObjectURL(blob)
				_this.download(blobUrl, 1)
			}
			req.send(JSON.stringify(params))
		},
		download (blobUrl, num) {
			const a = document.createElement('a')
			a.style.display = 'none'
			var date = new Date()
			var year = date.getFullYear()
			var month = date.getMonth() + 1
			var day = date.getDate()
			let name = num === 1 ? '客户价格信息(' + year + '-' + month + '-' + day + ').xlsx' : '客户信息(' + year + '-' + month + '-' + day + ').xlsx'
			a.download = name
			a.href = blobUrl
			a.click()
		},
		rowClick (row, column, event) {
			this.showClick(row)
		},
		changeNumber () {
			var reg = /^[1-9]\d*$|^(0)$/
			if (reg.test(this.codeNumber)) {
				if (this.codeNumber < 51 && this.codeNumber > 0) {
					this.waring = false
				} else {
					this.waring = true
					return false
				}
			} else {
				this.waring = true
				return false
			}
		},
		addCodeClick () {
			if (this.id === '-1') {
				this.$message.error('请先选择客户类别')
				return false
			}
			this.addCodeListModel = true
			this.ListStaffid = ''
			this.codeNumber = ''
		},
		cancelAddCode () {
			this.addCodeListModel = false
		},
		saveCode () {
			this.changeNumber()
			if (!this.waring) {
				let params = {
					customercategoryid: this.id,
					batchCount: +this.codeNumber,
					staffid: this.ListStaffid
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/customer/batchInvitation`,
					data: params
				}).then(res => {
					if (res.result) {
						this.$message.success('新增成功！')
						this.tableReload()
						this.addCodeListModel = false
					} else {
						this.$message.error(res.msg)
					}
				})
			}
		},
		getStaffList () {
			this.staffList = []
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/businessStaff/list`
			}).then(res => {
				if (res.result === true) {
					this.staffList = res.data
				}
			})
		},
		handleCollapse () {
			this.collapse = !this.collapse
			this.$refs.table.doLayout()
		},
		getAuthority (pid) {
			let params = {
				pId: pid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
					if (this.AuthorityList['03_0001_0003_00']) {
						this.isDisabled = false
					} else {
						this.isDisabled = true
					}
				}
			})
		},
		search () {
			// this.page = {
			// 	size: 20,
			// 	num: 1
			// }
			this.page.num = 1
			this.tableReload()
		},
		clear () {
			this.name = ''
			this.code = ''
			this.syscode = ''
			this.disabledflag = 0
			this.account = ''
			this.keyword = ''
			this.email = ''
			this.customerlevelid = ''
			this.customertagid = ''
			this.area = '0'
			this.province = ''
			this.city = ''
			this.district = ''
			this.creditFlag = -1
			this.creditlinetype = 0
			this.mincreditline = ''
			this.maxcreditline = ''
			this.shopNameIds = []
			this.search()
		},
		showClick (data) {
			this.$router.push({ path: 'customerView/customerInfo' })
			window.sessionStorage.setItem('customercategoryid', this.id)
			window.sessionStorage.setItem('customerid', data.customerid)
			window.sessionStorage.setItem('syscodeid', data.syscodeid)
			window.sessionStorage.setItem('customerName', data.customerName)
			window.sessionStorage.setItem('isCustomerAdd', false)
			let params = {
				customercategoryid: this.id,
				name: this.name,
				code: this.code,
				syscode: this.syscode,
				keyword: this.keyword,
				staffid: this.staffid,
				activationFlag: this.activationflag,
				invitationCode: this.invitationcode,
				size: this.page.size,
				page: this.page.num
			}
			window.sessionStorage.setItem('customerSelect', JSON.stringify(params))
		},
		addClick () {
			if (this.id === '-1') {
				this.$message.error('请先选择客户类别')
				return false
			}
			this.$router.push({ path: 'customerView/customerInfo' })
			window.sessionStorage.setItem('customercategoryid', this.id)
			window.sessionStorage.setItem('customerid', '')
			window.sessionStorage.setItem('syscodeid', '0')
			window.sessionStorage.setItem('isCustomerAdd', true)
		},
		unDisableClick () {
			if (this.ids.length === 0) {
				this.$message.error('请至少选择一个客户！')
				return false
			}
			let customerNames = this.ids.map(e => {
				return e.name
			}).join(',')
			let changeData = {
				pre: { lineSelect3: { type: '1' } },
				cur: { lineSelect3: { type: '2', customerName: customerNames, status: '启用' } }
			}
			const logger = this.$fxLogger.createInfo('custom.custom-file.update', changeData)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/enable`,
				data: this.ids,
				logger
			}).then(res => {
				if (res.result) {
					this.tableSelectUtils.clear()
					this.multiSetModel = false
					this.$message.success('启用成功')
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		disableClick () {
			if (this.ids.length === 0) {
				this.$message.error('请至少选择一个客户！')
				return false
			}
			let customerNames = this.ids.map(e => {
				return e.name
			}).join(',')
			let changeData = {
				pre: { lineSelect3: { type: '1' } },
				cur: { lineSelect3: { type: '2', customerName: customerNames, status: '停用' } }
			}
			const logger = this.$fxLogger.createInfo('custom.custom-file.update', changeData)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/disable`,
				data: this.ids,
				logger
			}).then(res => {
				if (res.result) {
					this.tableSelectUtils.clear()
					this.multiSetModel = false
					this.$message.success('停用成功')
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		otherPay () {
			if (this.friendpay === -1) {
				this.$message.error('请选择是否开启好友代付！')
				return false
			}
			let customerNames = this.ids.map(e => {
				return e.name
			}).join(',')
			let changeData = {
				pre: { lineSelect14: { type: '1' } },
				cur: { lineSelect14: { type: '2', customerName: customerNames, status: this.friendpay === '1' ? '开启好友代付' : '关闭好友代付' } }
			}
			const logger = this.$fxLogger.createInfo('custom.custom-file.update', changeData)
			let params = {
				payByFriendFlag: this.friendpay,
				customerIds: this.ids.map(e => { return e.customerid })
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/batchUpdateCustomerPayByFriendFlag`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.tableSelectUtils.clear()
					this.multiSetModel = false
					this.$message.success('修改成功')
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		// 设置最大金额最小金额
		savePrice () {
			let customerNames = this.ids.map(e => {
				return e.name
			}).join(',')
			let text = customerNames + `修改为最小订货金额限制${this.minBuyMoney}元，最大订货金额限制为${this.maxBuyMoney}元`
			const logger = this.$fxLogger.createInfo('custom.custom-file.muti', text)
			let params = {
				minBuyMoney: this.minBuyMoney,
				maxBuyMoney: this.maxBuyMoney,
				customerIds: this.ids.map(e => { return e.customerid })
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/batchUpdateCustomerBuyMoney`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.tableSelectUtils.clear()
					this.multiSetModel = false
					this.$message.success('修改成功')
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		choseCustomerCategory (value) {
			// 通过value找到对应的选项对象
			const selectedOption = this.customerList.find(option => option.ccid === value)
			if (selectedOption) {
				this.customerCategoryName = selectedOption.ccname
				this.customerCategoryError = false
			} else {
				this.customerCategoryName = ''
				this.customerCategoryError = true
			}
		},
		// 批量设置客户类别
		savecustomerCategory () {
			if (!this.customerCategoryId) {
				this.$message.error('请选择客户类别')
				this.customerCategoryError = true
				return false
			}
			let customerNames = this.ids.map(e => {
				return e.name
			}).join(',')
			let text = `将客户名称[` + customerNames + `]的客户类别批量修改为[${this.customerCategoryName}]`
			const logger = this.$fxLogger.createInfo('custom.custom-file.muti', text)
			let params = {
				customercategoryid: this.customerCategoryId,
				customerIds: this.ids.map(e => { return e.customerid })
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/bindCategory`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.tableSelectUtils.clear()
					this.multiSetModel = false
					this.$message.success('修改成功')
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		// 退款方式
		returnPaymode () {
			let customerNames = this.ids.map(e => {
				return e.name
			}).join(',')
			let params = {
				customerIds: this.ids.map(e => { return e.customerid }),
				name: customerNames,
				refundmodelist: this.paymodeList.filter(item => !item.disabled && item.paymode !== 15).map(item => {
					return {
						mode: item.mode,
						paymode: item.paymode
					}
				}) // TODO 过滤拉卡拉全渠道-收银台
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/updatecustomerrefundpaymodenew`,
				data: params
			}).then(res => {
				if (res.result) {
					this.tableSelectUtils.clear()
					this.multiSetModel = false
					this.$message.success('修改成功')
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		// 批量设置
		multiClick () {
			if (this.ids.length === 0) {
				this.$message.error('请至少勾选一条客户档案！')
				return false
			}
			this.multiSetModel = true
			this.relAllShopFlag = 1
			this.friendpay = -1
			this.chooseShop = []
			this.shopText = ''
			// 如果当前选中的是客户类别，默认选中第一个选项
			if (this.lineSelect === '17' && this.customerList && this.customerList.length > 0) {
				this.customerCategoryId = this.customerList[0].ccid
				this.customerCategoryName = this.customerList[0].ccname
				this.customerCategoryError = false
			}
		},
		cancelLine () {
			this.multiSetModel = false
			this.lineRadio = '1'
			this.selectLineList = []
			this.lineList.forEach(e => {
				e.checked = false
			})
			this.fixLineList.forEach(e => {
				e.checked = false
			})
			this.payTypeRadio = []
			this.payTypeRadio2 = []
			this.lineSelect = '0'
			this.selectLevelList = []
			this.levelList.forEach(e => {
				e.checked = false
			})
			this.fixLevelList.forEach(e => {
				e.checked = false
			})
			this.levelRadio = '1'
			this.creditline = ''
			this.creditlineflag = 0
			this.customerCategoryId = ''
			this.customerCategoryName = ''
			this.customerCategoryError = false
		},
		lineInput (e) {
			this.lineList = this.fixLineList.filter(e => {
				return e.codeandname.indexOf(this.lineValue) !== -1
			})
		},
		levelInput (e) {
			this.levelList = this.fixLevelList.filter(e => {
				return (e.customerlevelname.indexOf(this.levelValue) !== -1 || e.levelName.indexOf(this.levelValue) !== -1)
			})
		},
		saveLine () {
			let customerIds = this.ids.map(e => {
				return e.customerid
			})
			let customerNames = this.ids.map(e => {
				return e.name
			}).join(',')
			if (this.lineRadio === '1') {
				if (this.selectLineList.length === 0) {
					this.$message.error('请选择关联数据！')
					return false
				}
				this.$confirm('是否确认修改？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					let params = {
						customerIds: customerIds,
						lineid: this.selectLineList[0].lineid
					}
					let changeData = {
						pre: { lineSelect: { type: '1' } },
						cur: { lineSelect: { type: '2', customerName: customerNames, lineName: this.selectLineList[0].codeandname } }
					}
					const logger = this.$fxLogger.createInfo('custom.custom-file.update', changeData)
					this.$store.dispatch('requestPost', {
						url: `${this.$fxBaseApi.urlQIVShop}/customer/updateline`,
						data: params,
						logger
					}).then(res => {
						if (res.result) {
							this.tableSelectUtils.clear()
							this.$message.success('修改成功')
							this.multiSetModel = false
							this.tableReload()
						} else {
							this.$message.error(res.msg)
						}
					}).catch(err => {
						this.$message.error(err.msg)
					})
				})
			} else {
				let params = {
					customerIds: customerIds,
					lineid: ''
				}
				let changeData = {
					pre: { lineSelect: { type: '1' } },
					cur: { lineSelect: { type: '3', customerName: customerNames } }
				}
				const logger = this.$fxLogger.createInfo('custom.custom-file.update', changeData)
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/customer/updateline`,
					data: params,
					logger
				}).then(res => {
					if (res.result) {
						this.$message.success('修改成功')
						this.multiSetModel = false
						this.tableReload()
					} else {
						this.$message.error(res.msg)
					}
				}).catch(err => {
					this.$message.error(err.msg)
				})
			}
		},
		saveMultiLevel () {
			let customerIds = this.ids.map(e => {
				return e.customerid
			})
			let customerNames = this.ids.map(e => {
				return e.name
			}).join(',')
			if (this.levelRadio === '1') {
				if (this.selectLevelList.length === 0) {
					this.$message.error('请选择关联数据！')
					return false
				}
				this.$confirm('是否确认修改？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					let params = {
						customerIds: customerIds,
						customerlevelid: this.selectLevelList[0].customerlevelid
					}
					let changeData = {
						pre: { lineSelect2: { type: '1' } },
						cur: { lineSelect2: { type: '2', customerName: customerNames, levelName: this.selectLevelList[0].customerlevelname } }
					}
					const logger = this.$fxLogger.createInfo('custom.custom-file.update', changeData)
					this.$store.dispatch('requestPost', {
						url: `${this.$fxBaseApi.urlQIVShop}/customer/updatelevel`,
						data: params,
						logger
					}).then(res => {
						if (res.result) {
							this.tableSelectUtils.clear()
							this.$message.success('修改成功')
							this.multiSetModel = false
							this.tableReload()
						} else {
							this.$message.error(res.msg)
						}
					}).catch(err => {
						this.$message.error(err.msg)
					})
				})
			} else {
				let params = {
					customerIds: customerIds,
					customerlevelid: ''
				}
				let changeData = {
					pre: { lineSelect2: { type: '1' } },
					cur: { lineSelect2: { type: '3', customerName: customerNames } }
				}
				const logger = this.$fxLogger.createInfo('custom.custom-file.update', changeData)
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/customer/updatelevel`,
					data: params,
					logger
				}).then(res => {
					if (res.result) {
						this.$message.success('修改成功')
						this.multiSetModel = false
						this.tableReload()
					} else {
						this.$message.error(res.msg)
					}
				}).catch(err => {
					this.$message.error(err.msg)
				})
			}
		},
		getLevelList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/getCustomerLevelList`
			}).then(res => {
				res.data.forEach(e => {
					e.checked = false
				})
				this.fixLevelList = res.data
				this.levelList = res.data
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		gettagList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/getCustomerTagList`
			}).then(res => {
				this.tagList = res.data
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		// 获取客户类别
		getCustomer () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customerCategory/list`
			}).then(res => {
				if (res.result) {
					this.customerList = res.data.childNode
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		getLineList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/line/listfilter`
			}).then(res => {
				res.forEach(e => {
					e.checked = false
				})
				this.fixLineList = res
				this.lineList = res
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		selectLine (item) {
			this.lineList.forEach(e => {
				e.checked = false
				if (e.lineid === item.lineid) {
					e.checked = true
				}
			})
			this.fixLineList.forEach(e => {
				e.checked = false
				if (e.lineid === item.lineid) {
					e.checked = true
				}
			})
			this.selectLineList = [item]
		},
		selectLevel (item) {
			this.levelList.forEach(e => {
				e.checked = false
				if (e.customerlevelid === item.customerlevelid) {
					e.checked = true
				}
			})
			this.fixLevelList.forEach(e => {
				e.checked = false
				if (e.customerlevelid === item.customerlevelid) {
					e.checked = true
				}
			})
			this.selectLevelList = [item]
		},
		deleteClick (data) {
			this.$confirm('确认删除该客户和相关提成方案？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let a = [{ id: data.customerid, syscodeid: data.syscodeid, code: data.customerCode }]
				const logger = this.$fxLogger.createInfo('custom.custom-file.delete', { name: data.customerName })
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/customer/remove`,
					data: a,
					logger
				}).then(res => {
					if (res.result) {
						this.$message.success('删除成功')
						this.tableReload()
					} else {
						this.$message.error(res.msg)
					}
				}).catch(err => {
					this.$message.error(err.msg)
				})
			})
		},
		deletePriceList () {
			if (this.ids.length === 0) {
				this.$message.error('请至少选择一个客户！')
				return false
			}
			let customerNames = this.ids.map(e => {
				return e.name
			}).join(',')
			let customerIds = this.ids.map(e => {
				return e.customerid
			})
			this.$confirm('是否确认删除' + this.ids.length + '个客户的客户专有价格', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let changeData = {
					pre: { lineSelect10: { type: '1' } },
					cur: { lineSelect10: { type: '2', customerName: customerNames } }
				}
				const logger = this.$fxLogger.createInfo('custom.custom-file.update', changeData)
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/customer/delProductPrice`,
					data: { customerIds: customerIds },
					logger
				}).then(res => {
					if (res.result) {
						this.tableSelectUtils.clear()
						this.multiSetModel = false
						this.$message.success('客户专有价格删除成功')
						this.tableReload()
					} else {
						this.$message.error(res.msg)
					}
				}).catch(err => {
					this.$message.error(err.msg)
				})
			})
		},
		deleteRelationList () {
			if (this.ids.length === 0) {
				this.$message.error('请至少选择一个客户！')
				return false
			}
			let customerNames = this.ids.map(e => {
				return e.name
			}).join(',')
			let customerIds = this.ids.map(e => {
				return e.customerid
			})
			this.$confirm('是否确认删除' + this.ids.length + '个客户与商品关系', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let changeData = {
					pre: { lineSelect11: { type: '1' } },
					cur: { lineSelect11: { type: '2', customerName: customerNames } }
				}
				const logger = this.$fxLogger.createInfo('custom.custom-file.update', changeData)
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/customer/delCustomerProduct`,
					data: { customerIds: customerIds },
					logger
				}).then(res => {
					if (res.result) {
						this.tableSelectUtils.clear()
						this.multiSetModel = false
						this.$message.success('客户与商品关系删除成功')
						this.tableReload()
					} else {
						this.$message.error(res.msg)
					}
				}).catch(err => {
					this.$message.error(err.msg)
				})
			})
		},
		deleteList () {
			if (this.ids.length === 0) {
				this.$message.error('请至少选择一个客户！')
				return false
			}
			let customerNames = this.ids.map(e => {
				return e.name
			}).join(',')
			this.$confirm('确认删除', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				const logger = this.$fxLogger.createInfo('custom.custom-file.delete', { name: customerNames })
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/customer/remove`,
					data: this.ids,
					logger
				}).then(res => {
					if (res.result) {
						this.tableSelectUtils.clear()
						this.multiSetModel = false
						this.$message.success('删除成功')
						this.tableReload()
					} else {
						this.$message.error(res.msg)
					}
				}).catch(err => {
					this.$message.error(err.msg)
				})
			})
		},
		saveAppendix (num) {
			let customerNames = this.ids.map(e => {
				return e.name
			}).join(',')
			let params = {
				customerIds: []
			}
			this.ids.forEach(item => {
				params.customerIds.push(item.customerid)
			})
			let changeData
			if (num === 1) {
				params.appendixOne = this.appendixOne
				changeData = {
					pre: { lineSelect12: { type: '1' } },
					cur: { lineSelect12: { type: '2', customerName: customerNames, appendix: this.appendixOne } }
				}
			}
			if (num === 2) {
				params.appendixTwo = this.appendixTwo
				changeData = {
					pre: { lineSelect13: { type: '1' } },
					cur: { lineSelect13: { type: '2', customerName: customerNames, appendix: this.appendixTwo } }
				}
			}
			const logger = this.$fxLogger.createInfo('custom.custom-file.update', changeData)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/batchUpdateCustomerAppendix`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.tableSelectUtils.clear()
					this.multiSetModel = false
					this.$message.success('操作成功')
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		handleSelectionChange (data) {
			this.tableSelectUtils.selectToggle(this.tableData, data)
		},
		tableSelectUtilsHandler (row) {
			return {
				id: row.customerid,
				syscodeid: row.syscodeid,
				customerid: row.customerid,
				code: row.customerCode,
				name: row.customerName
			}
		},
		tableReload () {
			this.index++
			let params = {
				index: this.index,
				customercategoryid: this.id,
				name: this.name,
				code: this.code,
				syscode: this.syscode,
				keyword: this.keyword,
				tel: this.account,
				customerlevelid: this.customerlevelid,
				customertagid: this.customertagid,
				area: this.area,
				province: this.province,
				city: this.city,
				district: this.district,
				email: this.email,
				size: this.page.size,
				page: this.page.num,
				creditlineflag: this.creditFlag,
				creditlinetype: this.creditlinetype,
				mincreditline: this.mincreditline ? +this.mincreditline : null,
				maxcreditline: this.maxcreditline ? +this.maxcreditline : null,
				relShopIdList: +this.shopNameIds ? this.shopNameIds : null
			}
			if (this.disabledflag !== -1) {
				params.disabledflag = this.disabledflag
			}
			this.params = params
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/list`,
				data: params
			}).then(res => {
				if (res.result) {
					if (res.data.index === this.index) {
						this.tableData = res.data.data
						// console.log(this.tableData)
						this.total = res.data.count
						this.$nextTick(() => {
							this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.table)
						})
					}
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		handleSizeChange (val) {
			this.page.num = 1
			this.page.size = val
			this.tableReload()
		},
		handlePageChange (val) {
			this.page.num = val
			this.tableReload()
		},
		changeSelect (e) {
			if (e === '15') {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/customer/tenpay/getopenflag`
				}).then(res => {
					this.openflag = res.data
					if (this.openflag === '1') {
						this.tenpayflag = '1'
					}
				}).catch(err => {
					this.$message.error(err.msg)
				})
			}
			if (e === '17') {
				// 切换到客户类别时，默认选中第一个选项
				if (this.customerList && this.customerList.length > 0) {
					this.customerCategoryId = this.customerList[0].ccid
					this.customerCategoryName = this.customerList[0].ccname
					this.customerCategoryError = false
				}
			} else {
				// 切换到其他选项时，清除客户类别错误状态
				this.customerCategoryError = false
			}
		},
		savePaytype () {
			if (this.payWayRadio === '1') {
				this.changePayWay()
			} else {
				this.delPayWay()
			}
		},
		changePayWay () {
			if (this.payTypeRadio.length === 0) {
				this.$message.error('至少选择一种支付方式')
				return false
			}
			let customerIds = this.ids.map(e => {
				return e.customerid
			})
			let customerNames = this.ids.map(e => {
				return e.name
			}).join(',')
			let params = {
				customerIds: customerIds,
				paymodes: this.payTypeRadio.join(','),
				name: customerNames
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/updateCustomerDefaultPaymode`,
				data: params
			}).then(res => {
				if (res.result) {
					this.tableSelectUtils.clear()
					this.$message.success('修改成功')
					this.multiSetModel = false
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		delPayWay () {
			if (this.payTypeRadio2.length === 0) {
				this.$message.error('至少选择一种支付方式')
				return false
			}
			let customerIds = this.ids.map(e => {
				return e.customerid
			})
			let params = {
				customerIds: customerIds,
				paymodes: this.payTypeRadio2.join(',')
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/delCustomerPaymodeBatch`,
				data: params
			}).then(res => {
				if (res.result) {
					this.tableSelectUtils.clear()
					this.$message.success('修改成功')
					this.multiSetModel = false
					this.tableReload()
				} else {
					if (res.code === 1234) {
						this.errorMsgList = res.msg.split(';')
						this.errorMsgModel = true
					} else {
						this.$message.error(res.msg)
					}
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		checkNum (value) {
			this.creditline = value.replace(/[^\d.]/g, '')
			this.creditline = value.replace(/^\./g, '')
			this.creditline = value.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.creditline = value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			this.creditline = value.replace(/^(\-)*(\d*)\.(\d\d).*$/, '$1$2.$3')
			this.creditline = value.indexOf('.') > 0 ? value.split('.')[0].substring(0, 7) + '.' + value.split('.')[1].substring(0, 2) : value.substring(0, 7)
		},
		getShopList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/selectShopList`
			}).then(res => {
				this.shopList = res
				// console.log(res)
			})
		},
		reload () {
			this.tableReload()
		}
	}
}
</script>
<style lang="stylus" scoped>
.container1{
	box-sizing :border-box;
	width: 100%;
	flex-direction: column !important;
	display :flex;
	overflow :hidden
	height: 100%
	.errormsgText{
		width:100%;
		text-align :left
		line-height:30px;
	}
	.batch-register-btn{
		cursor :pointer;
		color: var(--fx-primary-color);
		font-size: 12px;
		margin-left: 10px;
        display: flex;
        width: 120px;
        height: 32px;
        justify-content center;
        align-items center;
	}
	.excel-icon {
		display inline-block
		height 20px
		width 20px
		background-repeat no-repeat
		background-position center
		&.import-excel-icon {
			background-image: url('~images/icon/import-excel-icon.png')
		}
		&.export-excel-icon {
			background-image: url('~images/icon/export-excel-icon.png')
		}
	}
	.filters-box-row {
		display: flex;
		justify-content: space-between
		padding: 10px 0;
		width :100%;
		line-height :40px;
		// min-width :600px;
		border-bottom 1px solid #dce2fd
		// box-sizing: border-box
		.filters-container {
			display flex
			flex-wrap: wrap
			flex: 1
			overflow: hidden
			.input-box {
				display flex
				// width: 210px
				&>span {
					display: inline-block;
					text-align: right;
					width: 85px;
					margin-right: 5px
				}
				// &.input-box2 {
				// 	width: 190px
				// }
				.name-input{
					width:140px
				}
				// .filter-input {
				// 	flex: 1
				// }
			}
			.input-box3 {
				display flex
				.name-input{
					width:140px
					margin-right: 10px
				}
			}
			// .input-box4 {
			// 	width:300px
			// }
			.btn {
				height: 32px
				margin-top: 4px
				margin-left 20px
			}
		}
		.search-right-wrap {
			width: 200px;
			flex-shrink: 0;
			line-height: 40px
		}
	}
	.btn-search-box{
		height :40px;
		margin-top 10px
		display :flex
	}
	.btn-box{
		margin-top 10px
		display :flex
	}
	.table-box{
		flex :1;
		box-sizing :border-box;
		min-height :0px;
	}
	.confirm-dialog {
		text-align left
		.dialog-container {
			display: flex
			flex-flow: column
			.item {
				display: flex;
				align-items: center;
				line-height: 70px;
				img {
					padding-right: 31px
				}
				span {
					font-size: 16px;
					font-weight: 400;
					color: #333333;
				}
				.search-btn {
					position: absolute;
					right: 20px;
					font-size: 12px;
					text-decoration: underline;
					color: var(--fx-primary-color);
					cursor: pointer;
				}
			}
		}
		.el-dialog {
			.btn-box {
				margin-top 15px;
				display flex
				justify-content center
				.btn {
					width: 120px;
				}
			}
		}
		.dialog-container{
			.input-box{
				display: flex
				align-items: center
				margin-bottom:20px;
				.input-span{
					width:180px;
					margin-left:10px
				}
				.change-title {
					margin-right: 30px;
					display: inline-block;
					min-width: 42px;
					vertical-align: top;
				}
				.change-right {
					margin-top: 3px;
					display: inline-block;
					.pay-type-box {
						display: flex;
						flex-flow: column;
						.el-radio {
							margin-top: 20px;
							&:nth-of-type(1) {
								margin-top: 0;
							}
						}
					}
					.table-row {
						display: flex;
						align-items: center
						justify-content: space-around;
						text-align: left;
						margin: 10px 0;
						.select-box2{
							width:170px;
							margin-right: 70px;
						}
					}
					&.customer-category-wrapper {
						position: relative;
						.customer-category-error {
							position: absolute;
							top: 100%;
							left: 0;
							color: red;
							font-size: 12px;
							white-space: nowrap;
						}
					}
				}
				.line-box {
					display: inline-block;
					border: 1px dashed #e4e4e4;
					width: 230px;
					height: 265px;
					box-sizing: border-box;
					padding: 0;
					margin-top: 15px;
					.box_title {
						padding: 0 10px;
						height: 32px;
						line-height: 32px;
						border-bottom: 1px solid #e9e9e9;
						font-size: 12px;
						color: #9f9f9f;
					}
					.box_list {
						overflow-y: auto;
						overflow-x: auto;
						height: 230px;
						background-color: #fff;
					}
					.member li {
						padding: 0 10px;
						height: 32px;
						line-height: 32px;
						border-bottom: 1px solid #e9e9e9;
						display: block;
						white-space: nowrap;
						text-overflow: ellipsis;
						color: #9f9f9f;
						overflow: hidden;
						cursor: pointer;
					}
					.cl:after {
						content: "";
						display: block;
						height: 0;
						clear: both;
						visibility: hidden;
					}
					.box_search {
						border-bottom: 1px solid #e9e9e9;
						position: relative;
						.add-icon {
							position: absolute;
							right: 5px;
							top: 6px;
							color: var(--fx-primary-color);
							font-size: 18px;
							cursor: pointer
						}
					}
					.px_search {
						border: none;
						box-shadow: none;
						height: 32px;
						line-height: 18px;
						background-position: 8px 9px;
						font-size: 12px;
						padding-right: 32px;
						padding-left: 10px;
						outline: none;
					}
					.box_list_body {
						height: 230px;
						position: relative;
						overflow: hidden;
					}
					.box_list_main {
						position: absolute;
						top: 0;
						left: 0;
						right: 0;
					}
					.line-check {
						display: flex;
						align-items: center;
						height: 100%;
						float: left;
						margin-right: 10px;
						img {
							display: inline-block;
							width: 18px;
							height: 18px;
						}
					}
					.mod_appicon {
						vertical-align: middle;
						position: relative;
						top: -1px;
						display: inline-block;
						width: 100%;
						span {
							color: #4b4b4b;
							width: 165px;
							overflow-x: hidden;
							text-align: left;
							overflow: hidden;
							display: block;
							white-space: nowrap;
							text-overflow: ellipsis;
							float: left;
							font-size: 12px;
							word-break: break-all;
						}
					}
				}
			}
		}
	}
	.confirm-dialog2 {
		.dialog-box {
			display: flex
			flex-flow: column
			align-items: center
			justify-content: center
			.title, .tips1 {
				font-size: 15px;
				font-weight: bold;
				color: #333333;
				padding: 18px 0
			}
			.tips2 {
				font-size: 12px;
				font-weight: 400;
				color: #808080;
			}
		}
	}
	.bar-wrap {
		max-height: 300px;
		overflow-y: auto;
		.bar-box {
			display: flex;
			align-items: center;
			padding-right: 20px;
			line-height: 20px;
			margin-bottom: 15px;
			.bar-content {
				flex: 1;
				padding: 0 20px
				display:flex
				align-items:center
			}
			.bar-delete {
				margin-left: auto;
				flex-shrink: 0;
				text-decoration: underline;
				color: var(--fx-primary-color);
				cursor: pointer;
				font-size: 13px
			}
		}
	}
}

</style>
<style lang="stylus">
.el-dialog__body{
	padding: 10px 20px 20px 20px;
}
.cell{
	padding :0 !important
}
.dialog-title1{
	text-align :left
	.el-dialog__body {
		padding-top: 0
	}
	.valet-foot {
		text-align: center;
		margin-top: 20px
	}
}
.confirm-dialog2 {
	.el-dialog__header {
		display: none
	}
}
</style>
